import {
  chakra,
  Divider,
  Flex,
  HStack,
  Icon,
  Stack,
  Text,
} from '@chakra-ui/react';
import { FaRegClock } from 'react-icons/fa';
import { GoPeople } from 'react-icons/go';
import { DtType, ProjectStatus } from '../../generated/graphql';
import { getIndustryDetails } from '../../utils/industryDetails';
import { formatDateShort } from '../../utils/formatDate';
import { HelivanColor } from '../helivan/HelivanColor';
import { HelivanLabel } from '../helivan/HelivanLabel';
import { HelivanText } from '../helivan/HelivanText';

interface EvaluationCardProps {
  id: string;
  title: string;
  dateCreated: string;
  onClick?: () => void;
  status?: ProjectStatus;
  numberModels: number;
}

export const EvaluationCard = ({
  id,
  title,
  dateCreated,
  onClick,
  status = ProjectStatus.Completed,
  numberModels,
}: EvaluationCardProps) => {
  const industryDetails = getIndustryDetails(DtType.Model).industryDetails;

  return (
    <Flex
      width="full"
      minWidth="330px"
      py="20px"
      px="30px"
      borderRadius="12px"
      borderColor={HelivanColor.border.primary}
      borderWidth="1px"
      flexDirection="column"
      height="full"
      justifyContent="space-between"
      gap="16px"
      bg={
        status === ProjectStatus.Completed
          ? 'white'
          : HelivanColor.background.secondary
      }
      _hover={
        onClick
          ? {
              cursor: 'pointer',
              boxShadow: '0px 0px 6px 2px rgba(0, 0, 0, 0.15)',
            }
          : undefined
      }
      transition="0.2s"
      onClick={onClick}
    >
      <Flex width="full" justifyContent="space-between">
        <Text fontSize="20px" fontWeight={600}>
          {title}
        </Text>
        {status === ProjectStatus.InProgress ? (
          <HelivanLabel label="Generating" variant="blueDark" />
        ) : status === ProjectStatus.Failed ? (
          <HelivanLabel label="Failed" variant="error" />
        ) : null}
      </Flex>
      <HStack spacing={3}>
        <FaRegClock size={16} color={HelivanColor.text.blueDark} />
        <HelivanText variant="smallBody">
          {formatDateShort(dateCreated)}
        </HelivanText>
      </HStack>

      <Stack spacing={2}>
        <HelivanText variant="smallBody">
          <chakra.span fontWeight={600}>Model count:</chakra.span>{' '}
          {numberModels}
        </HelivanText>
      </Stack>
      <Stack spacing={4}>
        <Divider />
        <HStack spacing="6px" alignItems="center">
          <Icon
            padding={0}
            as={industryDetails.icon}
            width="34px"
            height="34px"
            color={HelivanColor.text.helivanBlue}
          />
          <Stack spacing={0}>
            <HelivanText
              variant="largeBody+"
              colorOverride={HelivanColor.text.black}
            >
              {industryDetails.title}
            </HelivanText>
          </Stack>
        </HStack>
      </Stack>
    </Flex>
  );
};
